export default "__VITE_ASSET__nmmLInhc__"